



import { Vue, Component } from "vue-property-decorator";
import AdminList from "@/components/admin/adminList.vue";

@Component({
  name: "AdminUser",
  components: {
    AdminList,
  },
})
export default class AdminUser extends Vue {}
